module.exports = __webpack_public_path__ + "static/media/calling.ae2ae124.svg";